import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Login from '../screens/login/Login';
import HomeLayout from '../components/layout/HomeLayout';
import ProtectedRoute from './ProtectedRoute';
import { RouteConstants } from './RoutesConstant';
import Dashboard from '../screens/dashboard/Dashboard';
import AppLayout from '../components/layout/AppLayout';
import PermissionRoute from './PermissionRoute';
import WidgetSettings from '../screens/settings/WidgetSettings';
import UserProfile from '../screens/profile/UserProfile';
import { userRoleEnums } from '../hooks/custom-hooks/useAuthHook';

function AppRoutes() {
  return (
    <Routes>
      <Route element={<ProtectedRoute reverse />}>
        <Route path='login' element={<Login />} />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route element={<HomeLayout />}>
          <Route path='/' element={<Dashboard />} />
        </Route>
        <Route element={<HomeLayout />}>
          <Route element={<PermissionRoute allowedRoles={[userRoleEnums.CUSTOMER_ADMIN]} />}>
            <Route path='/widget-setting' element={<WidgetSettings />} />
          </Route>
        </Route>
        <Route element={<HomeLayout />}>
          <Route path='/user-profile' element={<UserProfile />} />
        </Route>
        <Route element={<AppLayout />}>
          {RouteConstants?.map((route) => (
            <Route key={route?.path} path={route?.path} element={route?.element}>
              {route?.child?.map((cRoute) => (
                <Route
                  key={cRoute?.path}
                  element={<PermissionRoute allowedRoles={cRoute?.allowedRoles} />}
                >
                  <Route path={cRoute?.path} element={cRoute?.element} />
                </Route>
              ))}
            </Route>
          ))}
        </Route>
      </Route>
    </Routes>
  );
}

export default AppRoutes;
